﻿import {
	DriverId,
	DriverPropertyFlags,
	DriverResult,
	FullEntityRelation,
	getDriverConfiguration,
	InstallationByHostData, ParkingCategory
} from "@2d-front-monorepo/permits-business";

export default function getDriverHiddenFields(installation: InstallationByHostData, driver: FullEntityRelation<DriverId, DriverResult> | undefined, category: ParkingCategory): DriverPropertyFlags {
	if (driver == null) {
		return Number.MAX_SAFE_INTEGER;
	}

	const entity = driver.original.entity;
	return getDriverConfiguration(installation, entity.type, category).fieldRules.hidden;
}
